export const parsePagination = ({ current_page: currentPage, total_pages: totalPages, total }) => {
  return { currentPage, totalPages, total };
};
